export default __webpack_public_path__ + "static/website-header-logo@2x-bf3add55d9e32e28cb70e51e769693bc.png";